import { FormControl, FormGroup, Validators } from '@angular/forms';

export class ContractForm extends FormGroup<{
  id: FormControl<undefined | number | null>;
  contractName: FormControl<string | null | undefined>;
  startDate: FormControl<Date | null | undefined>;
  expirationDate: FormControl<Date | null | undefined>;
  cancellationReminderDate: FormControl<Date | null | undefined>;
  earlyTerminationClause: FormControl<boolean | null>;
  cancellationDeliveryMethod: FormControl<
    ('Certified Mail' | 'Standard Mail' | 'E-Mail' | 'Fax') | null
  >;
  totalContractValue: FormControl<number | null>;
  contractFrequency: FormControl<number | null>;
  autoRenewing: FormControl<boolean | null>;
  renewalTerm: FormControl<number | null>;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      contractName: new FormControl<string>('', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      startDate: new FormControl<Date | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      expirationDate: new FormControl<undefined | Date>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      cancellationReminderDate: new FormControl<Date | null>(null),
      earlyTerminationClause: new FormControl<boolean | null>(null),
      cancellationDeliveryMethod: new FormControl<
        ('Certified Mail' | 'Standard Mail' | 'E-Mail' | 'Fax') | null
      >(null),
      totalContractValue: new FormControl<number | null>(null),
      contractFrequency: new FormControl<number | null>(null),
      autoRenewing: new FormControl<boolean | null>(null),
      renewalTerm: new FormControl<number | null>(null)
    });
  }
}
